import { FinOpsTrackingViewTypeEnum, IFinOpsBaseline, IFinOpsBudgetAllocationCombined } from "../../../models/FinOpsBudgets";
import { LogComponent, LogElement } from "../../../models/LogModel";
import React, { useState } from "react";
import {
  buildChartSeries,
  getCurrentMonth,
  getFiscalYearRange,
  getPreviousMonth,
} from "../../../utils/BudgetUtils";

import { ArrowCircleLeft24Filled } from "@fluentui/react-icons";
import { BudgetLineChart } from "../Common/BudgetLineChart";
import { BudgetOverviewCards } from "../Common/BudgetOverviewCard";
import { Button } from "@fluentui/react-components";
import FinOpsCostTable from "../Common/DetailTable";
import { currencyFormatter } from "../../../utils/currency";
import styles from "./BudgetTracking.less";

interface ServiceDrillDownLayoutProps {
  service: string;
  data: IFinOpsBudgetAllocationCombined[];
  baselineData: IFinOpsBaseline[];
  previousFyData: IFinOpsBudgetAllocationCombined[];
  isLoadingBudgetData: boolean;
  currentFiscalYear: string;
  onBack: () => void;
}

function getAllMonthsBetween(start: Date, end: Date): string[] {
  const months: string[] = [];
  const current = new Date(start.getFullYear(), start.getMonth(), 1);

  while (current <= end) {
    const year = current.getFullYear();
    const month = (current.getMonth() + 1).toString().padStart(2, "0");
    months.push(`${year}-${month}`);
    current.setMonth(current.getMonth() + 1);
  }

  return months;
}


const ServiceDrillDownLayout: React.FC<ServiceDrillDownLayoutProps> = ({ service, data, baselineData, previousFyData, isLoadingBudgetData, currentFiscalYear, onBack }) => {
  const fiscalYears = Array.from({ length: parseInt(currentFiscalYear.slice(2)) - 26 + 1 }, (_, i) => `FY${26 + i}`);
  const [selectedFiscalYear, setSelectedFiscalYear] = useState(currentFiscalYear);

  const { start: fiscalStart, end: fiscalEnd } = React.useMemo(() => getFiscalYearRange(selectedFiscalYear), []);
  const allMonths = getAllMonthsBetween(fiscalStart, fiscalEnd);
  const currentMonth = getCurrentMonth();
  const lastMonth = getPreviousMonth();
  const previousFiscalYear = `FY${parseInt(selectedFiscalYear.slice(2)) - 1}`;
  const { start: prevFiscalStart, end: prevFiscalEnd } = React.useMemo(() => getFiscalYearRange(previousFiscalYear), []);

  const series = buildChartSeries(data, currentMonth);

  return (
    <div className={styles.serviceLayout}>
      <Button onClick={() => onBack()} icon={<ArrowCircleLeft24Filled/>} className={styles.backButton}>Back to Service</Button>
      <h1 className={styles.layoutTitle}>{service}</h1>

      <BudgetOverviewCards
        currentFiscalYear={selectedFiscalYear}
        previousFiscalYear={previousFiscalYear}
        currentMonth={currentMonth}
        data={data}
        baselineData={baselineData}
        isLoadingBudgetData={isLoadingBudgetData}
        currencyFormatter={currencyFormatter}
        viewType="overview"
      />

      {/* Line Chart */}
      <BudgetLineChart
        title="Budget vs Actuals"
        isLoading={false}
        series={series}
        logProps={{
          logComponent: LogComponent.BudgetTracking,
          logElement: LogElement.BudgetTrackingServiceLayout,
          customProperties: { service }
        }}
        fillMissingAbnormalData
        anomalies={[]}
        suffix=""
        hideLegend={true}
      />

      {/* Detail Table */}
      <FinOpsCostTable
        data={data}
        previousFyData={previousFyData}
        viewType={FinOpsTrackingViewTypeEnum.Service}
        isloading={isLoadingBudgetData}
        IsDrilldownView={true}
        currentFiscalYear={currentFiscalYear}
      />
    </div>
  );
};

export default ServiceDrillDownLayout;
